/**
 * GraphVis 图谱默认配置（项目配色）
 * 颜色格式为 GraphVis 所需的 "r,g,b"
 */

const COLORS = {
  brownDark: '61,43,40',
  brownMuted: '93,62,49',
  paper: '212,196,168',
  paperDark: '196,180,152',
  cream: '245,239,227',
  text: '90,74,58',
  textLight: '138,122,106',
  success: '74,103,54',
  white: '255,255,255',
  link: '212,196,168',
  linkDark: '230,218,196',
  linkActive: '196,180,152',
  person: '196,168,130',
  org: '107,142,78',
  location: '139,115,85',
  event: '184,168,140'
}

export const graphVisColors = COLORS

export const GRAPH_CATEGORY_OPTIONS = [
  { value: 'person', label: '人物', color: '#c4a882' },
  { value: 'org', label: '机构', color: '#6b8e4e' },
  { value: 'event', label: '事件', color: '#8b6914' },
  { value: 'location', label: '地点', color: '#8b7355' }
]

/**
 * @param {{ dark?: boolean }} options dark=true 用于实体详情深色底
 */
export function relationChartConfig(options = {}) {
  const dark = !!options.dark
  return {
    node: {
      label: {
        show: true,
        font: 'bold 15px "PingFang SC", "Noto Serif SC", sans-serif',
        color: COLORS.brownDark,
        textPosition: 'Bottom_Center',
        textOffsetY: 10,
        background: COLORS.cream
      },
      shape: 'circle',
      size: 56,
      imageScale: 0.9,
      color: COLORS.cream,
      borderColor: COLORS.paperDark,
      borderWidth: 4,
      selected: {
        borderWidth: 3,
        borderColor: COLORS.success,
        showShadow: true,
        shadowBlur: 24,
        shadowColor: COLORS.success
      }
    },
    link: {
      label: {
        show: false,
        color: dark ? COLORS.paper : COLORS.text,
        font: 'normal 12px "PingFang SC", "Noto Serif SC", sans-serif',
        background: dark ? COLORS.brownDark : COLORS.cream
      },
      lineType: 'straight',
      showArrow: true,
      arrowType: 'triangle',
      color: dark ? COLORS.linkDark : COLORS.link,
      lineWidth: 1.6,
      selected: {
        color: COLORS.linkActive,
        lineWidth: 2.4
      }
    },
    highLightNeiber: false
  }
}

export function styleByCategory(category = '', isFocus = false, image = '') {
  const map = {
    person: '#c4a882',
    org: '#6b8e4e',
    location: '#8b7355',
    event: '#8b6914'
  }
  const border = map[category] || '#c4b498'
  return {
    borderColor: border,
    fillColor: '#f5efe3',
    color: '#f5efe3',
    size: isFocus ? 72 : 56,
    borderWidth: isFocus ? 6 : 4,
    image,
    imageScale: 0.9,
    font: 'bold 15px "PingFang SC", "Noto Serif SC", sans-serif',
    fontColor: '#3d2b28',
    textPosition: 'Bottom_Center',
    textOffsetY: 10
  }
}
